module.exports = eval("try{require('http')}catch(e){}");